<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nuevo bordado estándar</h3>

          <!-- <h4>Características básicas</h4> -->
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.success.show" variant="success">{{
              form.success.text
            }}</b-alert>
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <!-- <h4>Características</h4> -->

            <b-form-row class="mt-4">
              <b-col>
                <b-form-row>
                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-reference"
                      label="Nombre"
                      label-for="input-reference"
                    >
                      <b-input-group>
                        <b-form-input
                          :state="validateState('reference')"
                          v-model="$v.form.reference.$model"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col :cols="3">
                    <b-form-group
                      id="input-group-categories"
                      label="Categorías bordado"
                      label-for="input-categories"
                    >
                      <b-input-group>
                        <multiselect
                          track-by="value"
                          :class="$v.form.categories.$error ? 'is-invalid' : ''"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="true"
                          placeholder=""
                          label="text"
                          v-model="$v.form.categories.$model"
                          :options="form.optionsCategories"
                        >
                        </multiselect>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-image"
                      label="Imagen"
                      label-for="input-image"
                    >
                      <b-form-file
                        accept="image/*"
                        id="image"
                        v-model="$v.form.image.$model"
                        @input="changedImage"
                        :state="validateState('image')"
                        aria-describedby="input-image-feedback"
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-form-invalid-feedback id="input-image-feedback"
                        >Debes seleccionar una imagen válida (formato PNG o
                        JPEG).</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-is_multicolor"
                      label="Tipo"
                      label-for="input-is_multicolor"
                    >
                      <b-input-group>
                        <b-form-checkbox
                          v-model="$v.form.is_multicolor.$model"
                          switch
                        >
                          Multicolor
                        </b-form-checkbox>
                      </b-input-group>
                      <b-input-group>
                        <b-form-checkbox
                          v-model="$v.form.is_monocolor.$model"
                          switch
                        >
                          Monocolor
                        </b-form-checkbox>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col :cols="2" v-if="$v.form.is_multicolor.$model">
                    <b-form-group
                      id="input-group-num_colors"
                      label="Número de hilos (multicolor)"
                      label-for="input-num_colors"
                    >
                      <b-form-input
                        :state="validateState('num_colors')"
                        v-model="$v.form.num_colors.$model"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col :cols="12">
                    <!-- Reference -->

                    <label>Tamaños habilitados</label>

                    <b-form-row>
                      <b-col
                        :cols="1"
                        v-for="(b, j) in $v.form.sizes.$each.$iter"
                        :key="j"
                      >
                        <b-form-group
                          id="input-group-subdomain"
                          label-for="input-subdomain"
                          class="mb-0"
                        >
                          <b-form-checkbox v-model="b.enabled.$model" switch>
                            {{ form.currentSizes[j].name }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-button class="mt-4" type="submit" variant="primary"
              >Guardar nuevo bordado</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminStandardEmbroideriesNewScreen',
  props: {},
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },

      categories: {
        required,
      },
      is_multicolor: {
        required,
      },
      num_colors: {},
      is_monocolor: {
        required,
      },
      sizes: {
        $each: {
          enabled: {
            required,
          },
        },
      },
      image: {
        isValidImage,
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',
      categories: [],
      is_multicolor: false,
      is_monocolor: false,
      num_colors: 2,
      sizes: [],
      image: null,
      imageURI: null,

      error: {
        show: false,
        text: '',
      },
      success: {
        show: false,
        text: '',
      },
      optionsCategories: [],
      currentSizes: [],
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    // actions.getTypographiesUnpaginated().then((res) => {
    //   res.data.results.map((y) => {
    //     this.form.optionsCategories.push({
    //       text: y.reference,
    //       value: y.reference,
    //     });
    //   });
    // });
    // actions.getInitials().then((x) => {
    //   if (x.data.count === 0) {
    //     store.setOverlayShow(false);
    //     this.addSize();
    //     this.addTypography();
    //   } else {
    //     const data = x.data.results[0];
    //     this.form.sizes = data.sizes;
    //     this.form.typographies = data.typographies;
    //   }
    //   store.setOverlayShow(false);
    // });

    let promises = [];

    promises.push(actions.getEmbroideryCategoriesUnpaginated());
    promises.push(actions.getEmbroiderySetting(1));

    Promise.all(promises).then((x) => {
      // 1st
      this.form.optionsCategories = x[0].data.results.map((y) => {
        return {
          value: y.id,
          text: y.reference,
        };
      });

      // 2nd
      this.form.currentSizes = x[1].data.sizes;

      this.form.currentSizes.map((y) => {
        this.form.sizes.push({ enabled: false });
      });
    });

    // $v.form.sizes.$each.$iter.forEach((element) => {});
    store.setOverlayShow(false);
  },
  methods: {
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    addSize() {
      this.form.sizes.push({ name: '', price: '0.0' });

      this.form.typographies.map((typo) => {
        typo.sizes.push({
          enabled: true,
          height: '0.0',
        });
      });
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$v.$reset();

      store.setOverlayShow(true);

      let data = new FormData();

      if (this.form.image !== null) {
        data.append('image', this.form.image);
      }

      data.append(
        'categories',
        JSON.stringify(this.form.categories.map((x) => x.value))
      );

      data.append('reference', this.form.reference);
      data.append('is_multicolor', this.form.is_multicolor);
      data.append('is_monocolor', this.form.is_monocolor);
      data.append('num_colors', this.form.num_colors);

      data.append('sizes', JSON.stringify(this.form.sizes));

      Sentry.setExtra('data', JSON.stringify(data));

      actions
        .postStandardEmbroidery(data)
        .then((x) => {
          store.setOverlayShow(false);

          this.$router.push({ name: 'AdminEmbroiderySettingsScreen' });
        })
        .catch((y) => {
          store.setOverlayShow(false);

          this.form.error = {
            show: true,
            text: 'Ha ocurrido un error inesperado',
          };
          console.error(y);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
